module.exports = __webpack_public_path__ + "static/img/task3.d5554899.png";